export default [
    {
        path: '/access-denied',
        name: '403',
        component: () => import('../pages/Error/403'),
    },
    {
        path: '/page-not-found',
        name: '404',
        component: () => import('../pages/Error/404'),
    },
    {
        path: '*',
        component: () => import('../pages/Error/404'),
    },
]